<div class="authPage">
  <div class="authFormPane">
    <a class="authLogo" routerLink="/login">
      <div class="logoBox"><img src="assets/img/icons/envision-menu-72px.png" alt="Urbanhub"></div>
      <span class="logoText"><b>Urban</b>hub</span>
    </a>

    <div class="authFormContent">
      <div>
        <a class="authLink authReturn" (click)="back()">{{ 'GENERAL.RETURN_LOGIN' | translate }}</a>
        <h1 class="authTitle">{{ 'RESET_EXPIRED.TITLE' | translate }}</h1>
        <p class="authSubtitle">{{ 'RESET_EXPIRED.INSTRUCTION' | translate }}</p>
      </div>

      <form class="authForm" [formGroup]="form" (ngSubmit)="update()">
        <div class="authField">
          <label for="resetUsername">{{ 'LOGIN.USERNAME' | translate }}</label>
          <mat-form-field appearance="outline" class="customMatFormField">
            <input id="resetUsername" type="text" matInput formControlName="username" autocomplete="username">
          </mat-form-field>
        </div>

        <div class="authField">
          <label for="oldPassword">{{ 'CHANGE_PASSWORD_DIALOG.OLD_PASSWORD' | translate }}</label>
          <mat-form-field appearance="outline" class="customMatFormField cutFieldBottom">
            <input id="oldPassword" [type]="hideOldPassword ? 'password' : 'text'" matInput
              formControlName="oldPassword" autocomplete="current-password">
            <div matSuffix [innerHTML]="icons[hideOldPassword ? 'visibility-off-outline' : 'visibility-outline']"
              class="pointer authFieldIcon" [class.hideIcon]="hideOldPassword" [class.showIcon]="!hideOldPassword"
              (click)="changeVisibility('old')"></div>
          </mat-form-field>
          @if (form.controls.oldPassword.hasError('wrongCredentials')) {
            <mat-error>{{ 'ERROR.WRONG_CREDENTIALS' | translate }}</mat-error>
          }
        </div>

        <div class="authField">
          <label for="newPassword">{{ 'CHANGE_PASSWORD_DIALOG.NEW_PASSWORD' | translate }}</label>
          <mat-form-field appearance="outline" class="customMatFormField cutFieldBottom">
            <input id="newPassword" [type]="hideNewPassword ? 'password' : 'text'" matInput
              formControlName="newPassword" autocomplete="new-password">
            <div matSuffix [innerHTML]="icons[hideNewPassword ? 'visibility-off-outline' : 'visibility-outline']"
              class="pointer authFieldIcon" [class.hideIcon]="hideNewPassword" [class.showIcon]="!hideNewPassword"
              (click)="changeVisibility('new')"></div>
          </mat-form-field>
          @if (form.controls.newPassword.hasError('rule')) {
            <mat-error>{{ 'CHANGE_PASSWORD_DIALOG.ERROR_SYNTAX' | translate }}</mat-error>
          } @else if (form.controls.newPassword.hasError('same')) {
            <mat-error>{{ 'CHANGE_PASSWORD_DIALOG.SAME_PASSWORD' | translate }}</mat-error>
          } @else {
            <p class="authHint">{{ 'CHANGE_PASSWORD_DIALOG.ERROR_SYNTAX' | translate }}</p>
          }
        </div>

        <div class="authField">
          <label for="confirmedNewPassword">{{ 'CHANGE_PASSWORD_DIALOG.CONFIRMED_NEW_PASSWORD' | translate }}</label>
          <mat-form-field appearance="outline" class="customMatFormField cutFieldBottom">
            <input id="confirmedNewPassword" [type]="hideConfirmedNewPassword ? 'password' : 'text'" matInput
              formControlName="confirmedNewPassword" autocomplete="new-password">
            <div matSuffix [innerHTML]="icons[hideConfirmedNewPassword ? 'visibility-off-outline' : 'visibility-outline']"
              class="pointer authFieldIcon" [class.hideIcon]="hideConfirmedNewPassword" [class.showIcon]="!hideConfirmedNewPassword"
              (click)="changeVisibility('confirmed')"></div>
          </mat-form-field>
          @if (form.controls.confirmedNewPassword.hasError('mismatch')) {
            <mat-error>{{ 'CHANGE_PASSWORD_DIALOG.ERROR_EQUAL' | translate }}</mat-error>
          }
        </div>

        @if (error) {
          <mat-error>{{ error.key | translate: error.params }}</mat-error>
        }

        <button id="confirmButton" type="submit" mat-flat-button class="actionButton authSubmit" [disabled]="saving">
          {{ 'CHANGE_PASSWORD_DIALOG.CONFIRM' | translate }}
        </button>
      </form>
    </div>
  </div>

  <div class="authVisualPane">
    <img class="authCityImg" src="assets/img/auth/city-square-light.png" alt="">
  </div>
</div>
